<!-- main section -->
<section class="banker">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-xl-6 col-lg-6">
                <div class="content">
                    <h1 class="heading"><span class="color">Investment Bankers</span> for New India</h1>
                    <p class="text">Partner with India’s leading financial experts to fuel your Business’s
                        Potential</p>
                    <div class="wrap">
                        <a href="tel:011-6700-0000" class="btn">Contact Us</a>
                        <span class="or">or</span>
                        <div class="">
                            <p class="callus">Call us at:</p>
                            <a href="tel:011-6700-0000" class="phone">011-6700-0000</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-xl-6 col-lg-6">
                <div class="hero_banner">
                    <span class="circle"></span>
                    <span class="circle2"></span>
                    <img src="../assets/images/icons/h1.png" class="icon1" alt="icon">
                    <img src="../assets/images/icons/h2.png" class="icon2" alt="icon">
                    <img src="../assets/images/icons/h3.png" class="icon3" alt="icon">
                    <span class="shadows"></span>
                    <img src="../assets/images/hero.png" class="hero" alt="hero">
                </div>
            </div>
        </div>
        <div class="legacy">
            <p class="title">BAJAJCAPITAL GROUP LEGACY</p>
            <ul class="lists">
                <li>
                    <img src="../assets/images/icons/1.png" width="14" alt="icon">
                    <strong>60+</strong> Years of Wealth Creation
                </li>
                <li>
                    <img src="../assets/images/icons/2.png" width="14" alt="icon">
                    <strong>10,000+</strong> Business Partners
                </li>
                <li>
                    <img src="../../assets/images/icons/3.png" width="14" alt="icon">
                    <strong>515+ Bn</strong> Asset Under Advisory
                </li>
                <li>
                    <img src="../../assets/images/icons/4.png" width="14" alt="icon">
                    <strong>11+ Bn</strong> Insurance Premium Collected (LI+GI)
                </li>
                <li>
                    <img src="../../assets/images/icons/5.png" width="14" alt="icon">
                    <strong>8 times</strong> CNBC TV18 Winners
                </li>
            </ul>
        </div>
    </div>
</section>
<section id="subheader" class="stickyHeader">
    <ul id="main-nav" class="nav container">
        <li>
            <button class="btn tabs" data-href="#partner" id="partnertab">Why Partner with us?</button>
        </li>
        <li>
            <button class="btn tabs" data-href="#association" id="associationtab">Stellar Associations</button>
        </li>
        <li>
            <button class="btn tabs" data-href="#spectrum" id="spectrumtab">Spectrum of Investment Banking
                Services</button>
        </li>

        <li class="dropdown">
            <button class="btn tabs dropbtn" data-href="#document" id="documenttab">
                Offer Documents
            </button>
            <ul class="dropdown-content">
                <li><a href="javascript:void(0)">Buyback</a></li>
                <li><a href="javascript:void(0)">Delisting</a></li>
                <li><a href="/ipo">IPO</a></li>
                <li><a href="javascript:void(0)">QIP</a></li>
                <li><a href="javascript:void(0)">Rights Issue</a></li>
                <li><a href="/track-record">Track Record</a></li>
                <li class="has-sub-takeover">
                    <a href="javascript:void(0)">Takeover</a>
                    <ul class="sub-takeover">
                        <li>
                            <a href="/assets/pdf/Hindustan-Agrigenetics-Limited-Letter-of-Offer-25-August-2025.pdf"
                                target="_blank">
                                Hindustan Agrigenetics Limited
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
        <li>
            <button class="btn tabs" data-href="#leadership" id="leadershiptab">Visionary Leadership</button>
        </li>
        <li>
            <button class="btn tabs" data-href="#getintouch" id="getintouchtab">Get in Touch</button>
        </li>
    </ul>
</section>

<section class="w_partner benefit" id="partner">
    <div class="container">
        <h2 class="title">Why Partner with Bajaj Capital Securities?</h2><br>
        <p class="text">Presenting BajajCapital Group Investment Banking Metrics</p>
        <div class="items">
            <div class="item_data">
                <div class="work_content">
                    <img src="../../assets/images/icons/work1.svg" class="img-fluid icon" alt="icon">
                    <h2 class="heading">Six decades of Legacy</h2>
                    <p class="description">One of the most trusted names in Indian merchant banking</p>
                </div>
            </div>
            <div class="item_data">
                <div class="work_content">
                    <img src="../../assets/images/icons/work2.svg" class="img-fluid icon" alt="icon">
                    <h2 class="heading">Proven Fundraising Success</h2>
                    <p class="description">With <strong>₹26,000+ crores raised</strong>, we consistently deliver
                        successful
                        outcomes across industries.</p>
                </div>
            </div>
            <div class="item_data">
                <div class="work_content">
                    <img src="../../assets/images/icons/work3.svg" class="img-fluid icon" alt="icon">
                    <h2 class="heading">Client Centric Solutions</h2>
                    <p class="description">We prioritize client needs, providing tailored financial solutions
                    </p>
                </div>
            </div>
            <div class="item_data">
                <div class="work_content">
                    <img src="../../assets/images/icons/work4.svg" class="img-fluid icon" alt="icon">
                    <h2 class="heading">Diverse Client Portfolio</h2>
                    <p class="description">We serve a diverse clientele—from corporates and fund houses to
                        family offices and institutions</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="association" id="association">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-3 col-xl-3">
                <div class="left" style="padding-left:10px;">
                    <h3 class="heading">Stellar <span class="subheading">Associations</span></h3>
                </div>
            </div>
            <div class="col-md-12 col-lg-9 col-xl-9">
                <article>
                    <div>
                        <ul>
                            <li><img src="../../assets/images/1.png" alt="Stellar Associations 1">
                            </li>
                            <li><img src="../../assets/images/2.png" alt="Stellar Associations 2">
                            </li>
                            <li><img src="../../assets/images/3.png" alt="Stellar Associations 3">
                            </li>
                            <li><img src="../../assets/images/4.png" alt="Stellar Associations 4">
                            </li>
                            <li><img src="../../assets/images/5.png" alt="Stellar Associations 5">
                            </li>
                            <li><img src="../../assets/images/6.png" alt="Stellar Associations 6">
                            </li>
                            <li><img src="../../assets/images/7.png" alt="Stellar Associations 7">
                            </li>
                            <li><img src="../../assets/images/8.png" alt="Stellar Associations 8">
                            </li>
                            <li><img src="../../assets/images/9.png" alt="Stellar Associations 9">
                            </li>
                            <li><img src="../../assets/images/10.png" alt="Stellar Associations 10">
                            </li>
                            <li><img src="../../assets/images/11.png" alt="Stellar Associations 11">
                            </li>
                            <li><img src="../../assets/images/12.png" alt="Stellar Associations 12">
                            </li>
                            <li><img src="../../assets/images/13.png" alt="Stellar Associations 13">
                            </li>
                            <li><img src="../../assets/images/14.png" alt="Stellar Associations 14">
                            </li>
                            <li><img src="../../assets/images/15.png" alt="Stellar Associations 15">
                            </li>
                            <li><img src="../../assets/images/16.png" alt="Stellar Associations 16">
                            </li>
                            <li><img src="../../assets/images/17.png" alt="Stellar Associations 17">
                            </li>
                            <li><img src="../../assets/images/18.png" alt="Stellar Associations 18">
                            </li>
                            <li><img src="../../assets/images/19.png" alt="Stellar Associations 19">
                            </li>
                            <li><img src="../../assets/images/20.png" alt="Stellar Associations 20">
                            </li>
                        </ul>
                    </div>
                    <div>
                        <ul>
                            <li><img src="../../assets/images/1.png" alt="Stellar Associations 1">
                            </li>
                            <li><img src="../../assets/images/2.png" alt="Stellar Associations 2">
                            </li>
                            <li><img src="../../assets/images/3.png" alt="Stellar Associations 3">
                            </li>
                            <li><img src="../../assets/images/4.png" alt="Stellar Associations 4">
                            </li>
                            <li><img src="../../assets/images/5.png" alt="Stellar Associations 5">
                            </li>
                            <li><img src="../../assets/images/6.png" alt="Stellar Associations 6">
                            </li>
                            <li><img src="../../assets/images/7.png" alt="Stellar Associations 7">
                            </li>
                            <li><img src="../../assets/images/8.png" alt="Stellar Associations 8">
                            </li>
                            <li><img src="../../assets/images/9.png" alt="Stellar Associations 9">
                            </li>
                            <li><img src="../../assets/images/10.png" alt="Stellar Associations 10">
                            </li>
                            <li><img src="../../assets/images/11.png" alt="Stellar Associations 11">
                            </li>
                            <li><img src="../../assets/images/12.png" alt="Stellar Associations 12">
                            </li>
                            <li><img src="../../assets/images/13.png" alt="Stellar Associations 13">
                            </li>
                            <li><img src="../../assets/images/14.png" alt="Stellar Associations 14">
                            </li>
                            <li><img src="../../assets/images/15.png" alt="Stellar Associations 15">
                            </li>
                            <li><img src="../../assets/images/16.png" alt="Stellar Associations 16">
                            </li>
                            <li><img src="../../assets/images/17.png" alt="Stellar Associations 17">
                            </li>
                            <li><img src="../../assets/images/18.png" alt="Stellar Associations 18">
                            </li>
                            <li><img src="../../assets/images/19.png" alt="Stellar Associations 19">
                            </li>
                            <li><img src="../../assets/images/20.png" alt="Stellar Associations 20">
                            </li>
                        </ul>
                    </div>
                </article>
            </div>
        </div>
    </div>
</section>

<section class="services" id="spectrum">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-4 col-xl-4">
                <div class="left">
                    <h3 class="heading">Full Spectrum of <span class="subheading">Investment Banking
                            Services</span></h3>
                    <img src="../../assets/images/_leftimg.png" class="img-fluid w-100" alt="img">
                </div>
            </div>
            <div class="col-md-12 col-lg-4 col-xl-4">
                <div class="right">
                    <p class="title">Capital Markets</p>
                    <div class="accordion-container">
                        <div class="accordion">
                            <button class="menu-button open">
                                <div class="d-flex align-items-center"><img src="../../assets/images/icons/apps.png"
                                        width="32" alt="icon apps" />
                                    Fund Raise</div><span class="icon">&plus;</span><span class="icon2">&minus;</span>
                            </button>
                            <div class="content" style="height: auto;">
                                <ul class="listing">
                                    <li class="lists">IPOs (Initial public offerings)</li>
                                    <li class="lists">FPOs (Follow-on Public Offers)</li>
                                    <li class="lists">OFS (Offer for Sale)</li>
                                    <li class="lists">QIPs (Qualified Institutional Placements)</li>
                                    <li class="lists">Rights Issue</li>
                                    <li class="lists">NCDs (Public & Private Placement of Non-Convertible Debentures)
                                    </li>
                                    <li class="lists">Overseas Listing</li>
                                    <li class="lists">IDRs (Indian Depository Receipts) & IPPs (Initial Public
                                        Placements)</li>
                                </ul>
                            </div>
                        </div>
                        <div class="accordion">
                            <button class="menu-button">
                                <div class="d-flex align-items-center"><img
                                        src="../../assets/images/icons/join_right.png" width="32" alt="icon join" />
                                    Advisory</div><span class="icon">&plus;</span><span class="icon2">&minus;</span>
                            </button>
                            <div class="content">
                                <ul class="listing">
                                    <li class="lists">Open Offers</li>
                                    <li class="lists">Buybacks of Shares</li>
                                    <li class="lists">Delisting of Companies</li>
                                    <li class="lists">SEBI Related Valuations & Certifications</li>
                                    <li class="lists"><a routerLink="/other-valuations"
                                            style="color: inherit; text-decoration: none;">Other Valuations &
                                            Certifications</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-4 col-xl-4">
                <div class="right">
                    <p class="title">Private Funding</p>
                    <div class="accordion-container">
                        <div class="accordion">
                            <button class="menu-button2 open">
                                <div class="d-flex align-items-center"><img src="./assets/images/icons/account_tree.png"
                                        width="32" alt="icon account tree" />
                                    Structured Finance</div><span class="icon">&plus;</span><span
                                    class="icon2">&minus;</span>
                            </button>
                            <div class="content" style="height: auto;">
                                <ul class="listing">
                                    <li class="lists">Special Situation</li>
                                    <li class="lists">Stress Funding</li>
                                    <li class="lists">Acquisition Finance</li>
                                    <li class="lists">Mezzanine Finance</li>
                                    <li class="lists">Promoter Funding</li>
                                </ul>
                            </div>
                        </div>
                        <div class="accordion">
                            <button class="menu-button2">
                                <div class="d-flex align-items-center"><img src="./assets/images/icons/money_bag.png"
                                        width="32" alt="money" />
                                    Debt Syndication</div><span class="icon">&plus;</span><span
                                    class="icon2">&minus;</span>
                            </button>
                            <div class="content">
                                <ul class="listing">
                                    <li class="lists">Project Finance</li>
                                    <li class="lists">Trade Finance</li>
                                    <li class="lists">Foreign Debt</li>
                                    <li class="lists">Foreign Bonds</li>
                                </ul>
                            </div>
                        </div>
                        <div class="accordion">
                            <button class="menu-button2">
                                <div class="d-flex align-items-center"><img src="./assets/images/icons/merge.png"
                                        width="32" alt="merge" />
                                    Pvt. Equity, Merger & Acquisition</div><span class="icon">&plus;</span><span
                                    class="icon2">&minus;</span>
                            </button>
                            <div class="content">
                                <ul class="listing">
                                    <li class="lists">Venture Capital Investments</li>
                                    <li class="lists">Private Equity (PE) Transactions</li>
                                    <li class="lists">PIPE (Private Investment in Public Equity)</li>
                                    <li class="lists">Divestments</li>
                                    <li class="lists">Mergers & Acquisitions (M&A)</li>
                                    <li class="lists">Strategic Stake Sales</li>
                                    <li class="lists">Joint Ventures (JVs)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<section class="visionary" id="document"></section>
<section class="visionary" id="leadership">
    <div class="content">
        <h4 class="title">Visionary Leadership</h4>
        <p class="text">Where Knowledge meets Passion & Results</p>
    </div>
    <!-- <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="profile-box">
                        <img src="../../assets/images/SanjivBajaj.png" class="img" alt="profile">
                        <h4 class="name">Mr. Sanjiv Bajaj</h4>
                        <p class="designation">Joint Chairman and Managing Director</p>
                        <ul class="points">
                            <li>Over 25 years of experience</li>
                            <li>Certified Financial Planner (CFP) and MBA (Finance)</li>
                            <li>Hosts Financial talk show- FINtastic Talks with 6 Lacs plus Unique viewership</li>
                        </ul>
                        <a href="https://www.bajajcapital.com/about-us/sanjivbajaj" target="_blank"
                            class="know btn">Know More</a>
                    </div>
                    <div class="profile-box">
                        <img src="../../assets/images/RajivBajaj.png" class="img" alt="profile">
                        <h4 class="name">Mr. Rajiv Bajaj</h4>
                        <p class="designation">Chairman and Managing Director</p>
                        <ul class="points">
                            <li>Over 30 years of experience</li>
                            <li>Holds strategic management experience in the fields of Investment Banking, Investment
                                Advisory, Insurance Brokerage, Financial Planning</li>
                        </ul>
                        <a href="https://www.bajajcapital.com/about-us/rajivbajaj" target="_blank" class="know btn">Know
                            More</a>
                    </div>
                    <div class="profile-box">
                        <img src="../../assets/images/TRPrashanth Kumar.png" class="img" alt="profile">
                        <h4 class="name">Mr. T R Prashanth Kumar</h4>
                        <p class="designation">WTD & CEO</p>
                        <ul class="points">
                            <li>Over 3 decades of experience</li>
                            <li>Professional seasoned Investment Banker</li>
                            <li>Worked with Investments banks like BOBCAPS, Edelweiss, HSBC Investsmart etc</li>
                        </ul>
                        <a href="https://www.linkedin.com/in/prashanth-kumar-a009a217?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                            target="_blank" class="know btn">Know More</a>
                    </div>
                    <div class="profile-box">
                        <img src="../../assets/images/PreetiSwaroop.png" class="img" alt="profile">
                        <h4 class="name">Ms. Preeti Swaroop
                        </h4>
                        <p class="designation">Director ( Client relationships, Deal structuring & Placement)</p>
                        <ul class="points">
                            <li>20+ years of experience</li>
                            <li>Expertise in Capital Markets, Project & Corporate Finance</li>
                            <li>Worked at BOBCAPS, Edelweiss, etc.</li>
                        </ul>
                        <a href="https://www.linkedin.com/in/preeti-swaroop-649940182?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                            target="_blank" class="know btn">Know More</a>
                    </div>
                    <div class="profile-box">
                        <img src="../../assets/images/GAkila.png" class="img" alt="profile">
                        <h4 class="name">Ms. G Akila</h4>
                        <p class="designation">Vice President (Execution, Compliance, SEBI & Exchange Interface)</p>
                        <ul class="points">
                            <li>17+ years of experience</li>
                            <li>Expertise in Capital Markets transactions, due diligence, etc.</li>
                            <li>Worked at Religare, Karvy, etc.</li>
                        </ul>
                        <a href="http://www.linkedin.com/in/akila-gopalakrishnan-42470431" target="_blank"
                            class="know btn">Know More</a>
                    </div>
                </div>
            </div> -->
    <div class="container">
        <!-- Swiper -->
        <div class="swiper mySwiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="profile-box">
                        <img src="./assets/images/SanjivBajaj.png" class="img" alt="profile">
                        <h4 class="name">Mr. Sanjiv Bajaj</h4>
                        <p class="designation">Director</p>
                        <ul class="points">
                            <li>Over 25 years of experience</li>
                            <li>Certified Financial Planner (CFP) and MBA (Finance)</li>
                            <li>Hosts Financial talk show- FINtastic Talks with 6 Lacs plus Unique viewership
                            </li>
                        </ul>
                        <a href="https://www.bajajcapital.com/about-us/sanjivbajaj" target="_blank"
                            class="know btn">Know More</a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="profile-box">
                        <img src="./assets/images/RajivBajaj.png" class="img" alt="profile">
                        <h4 class="name">Mr. Rajiv Bajaj</h4>
                        <p class="designation">Director</p>
                        <ul class="points">
                            <li>Over 30 years of experience</li>
                            <li>Holds strategic management experience in the fields of Investment Banking,
                                Investment
                                Advisory, Insurance Brokerage, Financial Planning</li>
                        </ul>
                        <a href="https://www.bajajcapital.com/about-us/rajivbajaj" target="_blank" class="know btn">Know
                            More</a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="profile-box">
                        <img src="./assets/images/TRPrashanth Kumar.png" class="img" alt="profile">
                        <h4 class="name">Mr. T R Prashanth Kumar</h4>
                        <p class="designation">WTD & CEO</p>
                        <ul class="points">
                            <li>Over 3 decades of experience</li>
                            <li>Professional seasoned Investment Banker</li>
                            <li>Worked with Investments banks like BOBCAPS, Edelweiss, HSBC Investsmart etc</li>
                        </ul>
                        <a href="https://www.linkedin.com/in/prashanth-kumar-a009a217?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                            target="_blank" class="know btn">Know More</a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="profile-box">
                        <img src="./assets/images/PreetiSwaroop.png" class="img" alt="profile">
                        <h4 class="name">Ms. Preeti Swaroop
                        </h4>
                        <p class="designation">Director ( Client relationships, Deal structuring & Placement)
                        </p>
                        <ul class="points">
                            <li>20+ years of experience</li>
                            <li>Expertise in Capital Markets, Project & Corporate Finance</li>
                            <li>Worked at BOBCAPS, Edelweiss, etc.</li>
                        </ul>
                        <a href="https://www.linkedin.com/in/preeti-swaroop-649940182?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                            target="_blank" class="know btn">Know More</a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="profile-box">
                        <img src="./assets/images/GAkila.png" class="img" alt="profile">
                        <h4 class="name">Ms. G Akila</h4>
                        <p class="designation">Vice President (Execution, Compliance, SEBI & Exchange Interface)
                        </p>
                        <ul class="points">
                            <li>17+ years of experience</li>
                            <li>Expertise in Capital Markets transactions, due diligence, etc.</li>
                            <li>Worked at Religare, Karvy, etc.</li>
                        </ul>
                        <a href="http://www.linkedin.com/in/akila-gopalakrishnan-42470431" target="_blank"
                            class="know btn">Know More</a>
                    </div>
                </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>

        <!-- Swiper JS -->
    </div>
</section>

<section class="resources">
    <div class="container">
        <h4 class="heading">Investor Resources</h4>
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-tab" data-bs-toggle="tab" href="#nav-home" role="tab"
                    aria-controls="nav-home" aria-selected="true">Investor Charter</a>
                <a class="nav-item nav-link" id="nav-profile-tab" data-bs-toggle="tab" href="#nav-profile" role="tab"
                    aria-controls="nav-profile" aria-selected="false">Investor Grievances Data</a>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <p class="title">Charters for Investors’ Awareness issued by SEBI</p>
                <div class="row">
                    <div class="col-md-12 col-xl-6 col-lg-6">
                        <ul class="sublist">
                            <li><a href="/assets/pdf/charter/Investor-charter-Delisting-of-Equity-Shares.pdf"
                                    target="_blank">Investor charter - Delisting of Equity
                                    Shares </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-IPOs-and-FPOs-including-OFS.pdf"
                                    target="_blank">Investor charter - IPOs and FPOs including
                                    OFS </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Preferential-Issue.pdf"
                                    target="_blank">Investor charter - Preferential Issue </a>
                            </li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Private-Placement-of-Municipal-Debt-Securities.pdf"
                                    target="_blank">Investor charter - Private Placement of
                                    Municipal Debt Securities </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Private-Placement-of-Non-Convertible-Securities.pdf"
                                    target="_blank">Investor charter - Private Placement of
                                    Non-Convertible Securities </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Private-Placement-of-units-by-InvITs.pdf"
                                    target="_blank">Investor charter - Private Placement of
                                    units by InvITs </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Rights-Issue.pdf" target="_blank">Investor
                                    charter- Rights Issue </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Buyback-of-Securities.pdf"
                                    target="_blank">Investor-charter - Buyback of Securities
                                </a></li>
                        </ul>
                    </div>
                    <div class="col-md-12 col-xl-6 col-lg-6">
                        <ul class="sublist">
                            <li><a href="/assets/pdf/charter/Investor-charter-Public-Issue-of-Debt-Securities.pdf"
                                    target="_blank">Investor charter - Public Issue of Debt
                                    Securities </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Public-issue-of-InvITS.pdf"
                                    target="_blank">Investor charter - Public issue of InvITS
                                </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Public-Issue-of-Non-Convertible-Redeemable-Preference-Shares-NCRPs.pdf"
                                    target="_blank">Investor charter - Public Issue of
                                    Non-Convertible Redeemable Preference Shares(NCRPs) </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Public-Issue-of-REITs.pdf"
                                    target="_blank">Investor charter - Public Issue of REITs
                                </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Qualified-Institutionsplacement-QIPs.pdf"
                                    target="_blank">Investor charter - Qualified
                                    Institutionsplacement (QIPs) </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-SME-IPOs-and-FPOs-including-OFS.pdf"
                                    target="_blank">Investor charter - SME IPOs and FPOs
                                    (including OFS) </a></li>
                            <li><a href="/assets/pdf/charter/Investor-charter-Substantial-Acquisition-of-Shares-and-Takeovers.pdf"
                                    target="_blank">Investor charter - Substantial Acquisition
                                    of Shares and Takeovers </a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                <div class="row">
                    <div class="col-md-12 col-xl-6 col-lg-6">
                        <ul class="sublist">
                            <li><a href="/assets/pdf/investor-complaints-data-october-2024.pdf" target="_blank">October
                                    2024</a></li>
                            <li><a href="/assets/pdf/investor-complaints-data-november-2024.pdf"
                                    target="_blank">November 2024</a></li>
                            <li><a href="/assets/pdf/Investor-Complaints-Data-December-2024.pdf"
                                    target="_blank">December 2024</a></li>
                            <li><a href="/assets/pdf/Investor-Complaints-Data-January-2025.pdf" target="_blank">January
                                    2025</a></li>
                            <li><a href="/assets/pdf/Investor-complaints-data-Feb-2025.pdf" target="_blank">February
                                    2025</a></li>
                            <li><a href="/assets/pdf/Investor-complaints-data-March-2025.pdf" target="_blank">March
                                    2025</a></li>
                            <li><a href="/assets/pdf/investor-complaints-april-2025.pdf" target="_blank">April 2025</a>
                            </li>
                            <li><a href="/assets/pdf/investor-complaints-may-2025.pdf" target="_blank">May 2025</a></li>
                            <li><a href="/assets/pdf/investor-complaints-june-2025.pdf" target="_blank">June 2025</a>
                            </li>
                            <li><a href="/assets/pdf/investor-complaints-july-2025.pdf" target="_blank">July 2025</a>
                            </li>
                            <li><a href="/assets/pdf/Investor-complaints-data-August-2025.pdf" target="_blank">August
                                    2025</a></li>
                            <li><a href="/assets/pdf/Investor-complaints-data-september-2025.pdf"
                                    target="_blank">September 2025</a></li>
                            <li><a href="/assets/pdf/Investor-complaints-data-october-2025.pdf" target="_blank">October
                                    2025</a></li>
                            <li><a href="/assets/pdf/Investor-complaints-data-november-2025.pdf"
                                    target="_blank">November 2025</a></li>
                            <li><a href="/assets/pdf/Investor-complaints-data-december-2025.pdf"
                                    target="_blank">December 2025</a></li>
                            <li><a href="/assets/pdf/Investor-complaints-data-january-2026.pdf" target="_blank">January
                                    2026</a></li>
                            <li><a href="/assets/pdf/BCSL-investors-complaints-data-february-2026.pdf" target="_blank">February
                                    2026</a></li>
                             <li><a href="/assets/pdf/BCSL-investors-complaints-data-march-2026.pdf" target="_blank">March
                                    2026</a></li>
                                    <li><a href="/assets/pdf/BCSL-investors-complaints-data-april-2026.pdf" target="_blank">April
                                    2026</a></li>
                                      <li><a href="/assets/pdf/BCSL-investors-complaints-data-may-2026.pdf" target="_blank">May
                                    2026</a></li>
                                    <li><a href="/assets/pdf/BCSL-investors-complaints-data-june-2026.pdf" target="_blank">June
                                    2026</a></li>
                                    <li><a href="/assets/pdf/BCSL-investors-complaints-data-july-2026.pdf" target="_blank">July
                                    2026</a></li>
                                    <li><a href="/assets/pdf/BCSL-investors-complaints-data-august-2026.pdf" target="_blank">August
                                    2026</a></li>
                                    <li><a href="/assets/pdf/BCSL-investors-complaints-data-october-2026.pdf" target="_blank">October
                                    2026</a></li>
                                    
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="maps" id="getintouch">
    <div class="container">
        <h5 class="heading">Get in Touch</h5>
        <iframe title="google map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14018.869454035172!2d77.2517182!3d28.5482139!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3cff4b0eae3%3A0x341e7717d870509b!2sBajaj%20Capital!5e0!3m2!1sen!2sin!4v1732350753879!5m2!1sen!2sin"
            height="450" style="border:0;width: 100%;border-radius: 10px;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="mt-5">
                    <h5>Bajaj Capital Securities Limited</h5>

                    <p>(formerly known as Bajaj Capital Holdings Limited)</p>
                    <p><strong>CIN:</strong> U65999DL2019PLC346813</p>
                    <p><strong> SEBI Merchant Banking Registration No.:</strong> INM000013208</p>
                    <p><strong> For lodging grievances: </strong> <a class=" mt-5 fw-bold"
                            href="https://scores.sebi.gov.in/"> SEBI SCORES</a></p>
                </div>
            </div>

        </div>


    </div>
</section>

<!-- main section -->
<button onclick="topFunction()" id="myBtn" title="Go to top" style="display: block;">
    <img src="../../assets/images/bottom.png" alt="top">
</button>